import { UserStatus } from '@repo-level/core-front';

import { CurrencyCode } from 'helpers/currency';
import { findGroup } from 'helpers/cms';
import { USER_GROUP } from 'helpers/user';
import { ProgressBarPalette } from 'components/progressBars/helpers';

export enum VipGroupName {
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
  DIAMOND = 'DIAMOND',
}

export const levelOrderMap: Record<VipGroupName, number> = {
  [VipGroupName.GOLD]: 0,
  [VipGroupName.PLATINUM]: 1,
  [VipGroupName.DIAMOND]: 2,
};

export const getUserVipGroup = (statuses?: UserStatus[]) => {
  if (!statuses) return;

  const findVipGroup = findGroup(statuses);

  if (findVipGroup(USER_GROUP.DIAMOND)) return VipGroupName.DIAMOND;
  if (findVipGroup(USER_GROUP.PLATINUM)) return VipGroupName.PLATINUM;
  if (findVipGroup(USER_GROUP.GOLD)) return VipGroupName.GOLD;

  return;
};

const upgradeVipPrices: Record<string, number> = {
  // fiat
  [CurrencyCode.AUD]: 1000,
  [CurrencyCode.CAD]: 1000,
  [CurrencyCode.EUR]: 1000,
  [CurrencyCode.USD]: 1000,
  [CurrencyCode.NZD]: 1000,
  [CurrencyCode.NOK]: 10000,

  // crypto
  [CurrencyCode.USDT]: 1000,
  [CurrencyCode.BTC]: 37,
  [CurrencyCode.BCH]: 4500,
  [CurrencyCode.LTC]: 15000,
  [CurrencyCode.ETH]: 600,
  [CurrencyCode.DOG]: 15000,
  [CurrencyCode.JPY]: 150000,
  [CurrencyCode.BRL]: 2000,
};

export const getUpgradeVipPrice = (userCurrencyCode: string) => {
  return upgradeVipPrices[userCurrencyCode];
};

export const VIP_CURRENT_COLOR = {
  [VipGroupName.GOLD]: ProgressBarPalette.YELLOW,
  [VipGroupName.PLATINUM]: ProgressBarPalette.PLATINUM,
  [VipGroupName.DIAMOND]: ProgressBarPalette.PURPLE,
};

export const PERCENT_BREACKPOINTS_STARDUST_RUSH = [
  {
    title: '1.2',
    percentage: 0,
  },
  {
    title: '1.5',
    percentage: 33.3,
  },
  {
    title: '1.7',
    percentage: 66.6,
  },
  {
    title: '2',
    percentage: 100,
  },
];
